<template lang="pug">
div
    button.button.is-light(style="padding:2rem;", v-if="language === 'en'", @click='spanish') español
    button.button.is-light(style="padding:2rem;", v-else, @click='english') English
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "Language",
  computed: {
    ...mapState(["language"])
  },
  props: {},
  methods: {
    spanish() {
      this.$store.commit("language", "es");
    },
    english() {
      this.$store.commit("language", "en");
    }
  }
};
</script>

<style scoped lang="less">
</style>
